import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { createGlobalStyle } from "styled-components";
import "./fonts/nunito-sans-v12-latin-regular.ttf";
import "./fonts/nunito-sans-v12-latin-regular.woff2";
import "./fonts/nunito-sans-v12-latin-regular.eot";
import "./fonts/nunito-sans-v12-latin-regular.woff";

const GlobalStyle = createGlobalStyle`
 {
    box-sizing: border-box;
  }

  body {
    font-family: 'Nunito Sans';
    margin: 0;
  }

  .btn-spinner.large {
    width: 25px;
    height: 25px;

    color: #85181D;
  }

  /* nunito-sans-regular - latin */
  @font-face {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    src: url('./fonts/nunito-sans-v12-latin-regular.eot'); /* IE9 Compat Modes */
    src: local('Nunito Sans'),
         url('./fonts/nunito-sans-v12-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('./fonts/nunito-sans-v12-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('./fonts/nunito-sans-v12-latin-regular.woff') format('woff'), /* Modern Browsers */
         url('./fonts/nunito-sans-v12-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('./fonts/nunito-sans-v12-latin-regular.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  

  
  
  


`;

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
